import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@mui/material';
import React from 'react';
import { useIsDesktop } from '../../../utils/mediaQueries';
import styles from '../styles';
const StackingCard = ({ children, color = '#fff', lvl, sectionName, }) => {
    const isDesktop = useIsDesktop();
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const gaSectionAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0]?.toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-type': 'Section',
    };
    return (_jsx(Card, { sx: {
            ...(isDesktop ? styles.desktopCard : styles.mobileCard),
            backgroundColor: color,
            zIndex: lvl,
            overflow: 'unset',
        }, className: 'stacking-card', ...gaSectionAttributes, children: children }));
};
export default StackingCard;
